module.exports = __webpack_public_path__ + "img/summary_item_bg1.b5ae0a39.png";